import { render, staticRenderFns } from "./VerDetalleDescargaActividadModal.vue?vue&type=template&id=53e31af5&"
import script from "./VerDetalleDescargaActividadModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleDescargaActividadModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports